import { validateCategoryUpload } from '../../../helpers/CategoryMedia'
import React, { useState, useEffect, useContext } from 'react'
import {
    Form,
    Button,
    Row,
    Col,
    Input,
    Card,
    CardBody,
    FormGroup,
    Label
} from 'reactstrap'
import { isEmpty } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { GeneralContext } from '../../../context/'
import ApiService from '../../../data/services/ApiService'
import { withRouter } from 'react-router-dom'

const FormPage = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [id, setId] = useState('')
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [image, setImage] = useState('')
    const [imagePath, setImagePath] = useState('')
    const [type, setType] = useState('CATALOG')
    const [artistPriceFactor, setArtistPriceFactor] = useState('1.00')
    const [artistBio, setArtistBio] = useState('')
    const [artistStatement, setArtistStatement] = useState('')
    const [artistWebsiteUrl, setArtistWebsiteUrl] = useState('')
    const [artistInstagramUrl, setArtistInstagramUrl] = useState('')
    const [artistCoverImage, setArtistCoverImage] = useState('')
    const [artistCoverImagePath, setArtistCoverImagePath] = useState('')

    useEffect(() => {
        if (!isEmpty(props.data)) {
            setId(props.data.id)
            setName(props.data.name)
            setDescription(props.data.description)
            setImage(props.data.image)
            setImagePath(props.data.imagePath || '')
            setType(props.data.type || 'CATALOG')
            setArtistPriceFactor(String(props.data.artistPriceFactor || 1))
            setArtistBio(props.data.artistBio || '')
            setArtistStatement(props.data.artistStatement || '')
            setArtistWebsiteUrl(props.data.artistWebsiteUrl || '')
            setArtistInstagramUrl(props.data.artistInstagramUrl || '')
            setArtistCoverImage(props.data.artistCoverImage || '')
            setArtistCoverImagePath(props.data.artistCoverImagePath || '')
        }
    }, [props.data])

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!_validateForm()) {
            toastr.error('No olvides llenar los campos.', 'Error')
            return
        }

        let data = {
            name,
            description,
            image,
            imagePath,
            type,
            artistPriceFactor: type === 'ARTIST' ? Number(artistPriceFactor) : 1,
            artistBio,
            artistStatement,
            artistWebsiteUrl,
            artistInstagramUrl,
            artistCoverImage,
            artistCoverImagePath
        }

        setLoading(true)
        try {
            const response = props.data !== undefined
                ? await ApiService.updateCategory({...data, id})
                : await ApiService.createCategory(data)
            if (!response.data.success || !response.data.data?.id) {
                throw new Error('La categoría no pudo verificarse después de guardar')
            }
            const reread = await ApiService.getCategoryById(response.data.data.id)
            if (!reread.data.data || Number(reread.data.data.artistPriceFactor) !== Number(data.artistPriceFactor)) {
                throw new Error('El factor guardado no coincide con el valor solicitado')
            }
            toastr.success(props.data !== undefined ? 'Edité una categoría' : 'Agregué una categoría', '¡Éxito!')
            if (props.data === undefined) _clearForm()
        } catch (error) {
            toastr.error(error.response?.data?.message || error.message || 'No pude guardar esta categoría', 'Error')
        } finally {
            setLoading(false)
        }
    }

    const _validateForm = () => {
        if (name === '') { return false }
        if (type === 'ARTIST' && (!Number.isFinite(Number(artistPriceFactor)) || Number(artistPriceFactor) < 1)) { return false }

        return true
    }

    const _clearForm = () => {
        document.getElementById('create').reset()
    }

    const _handleImageUpload = (event, onUploaded) => {
        let files = event.target.files
        const types = ['image/png', 'image/jpeg', 'image/gif']

        if (types.every(type => files[0].type !== type)) {
            toastr.error('Solo se aceptan imagenes', 'Error')

            return
        }
        setLoading(true)
        fileUpload(files[0]).then((response) => {
            onUploaded(validateCategoryUpload(response.data))
            setLoading(false)
            toastr.success('Subí la imagen', '¡Éxito!')
        }).catch(error => {
            console.log('fileUpload', error)
            setLoading(false)
            toastr.error('No pude subir la imagen', 'Error')
        })
    }

    const fileUpload = (file) => {
        const formData = new FormData()
        formData.append('file', file)

        return ApiService.uploadCategoryImage(formData)
    }

    const _handleFileUpload = (event) => {
        _handleImageUpload(event, (data) => {
            setImage(data.fileName)
            setImagePath(data.path || '')
        })
    }

    const _handleCoverFileUpload = (event) => {
        _handleImageUpload(event, (data) => {
            setArtistCoverImage(data.fileName)
            setArtistCoverImagePath(data.path || '')
        })
    }

    return (
        <React.Fragment>
            <Form id="create" method="POST" onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12}>
                        <Card style={{ textAlign: 'right' }}>
                            <CardBody>
                                <Button
                                    onClick={() => { window.history.go(-1) }}
                                    className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    <i className={`mdi mdi-check`}></i> Guardar
                                </Button>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={12}>
                                        <FormGroup>
                                            <Label>
                                                Nombre *
                                            </Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                value={name}
                                                onChange={event => setName(event.target.value)}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label htmlFor="name">
                                                Descripción
                                            </Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                value={description}
                                                onChange={event => setDescription(event.target.value)}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label>
                                                Tipo *
                                            </Label>
                                            <Input
                                                type="select"
                                                className="form-control"
                                                value={type}
                                                onChange={event => setType(event.target.value)}
                                            >
                                                <option value="CATALOG">Catálogo</option>
                                                <option value="ARTIST">Artista invitado</option>
                                            </Input>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label>Imagen de perfil / listado</Label>

                                            <Input type="file"
                                                id="image"
                                                onChange={_handleFileUpload}
                                            />
                                        </FormGroup>

                                        {type === 'ARTIST' && (
                                            <React.Fragment>
                                                <FormGroup>
                                                    <Label>Factor de precio del artista *</Label>
                                                    <Input
                                                        type="number"
                                                        min="1"
                                                        step="0.01"
                                                        value={artistPriceFactor}
                                                        onChange={event => setArtistPriceFactor(event.target.value)}
                                                    />
                                                    <small className="text-muted">
                                                        Precio público = precio base configurado × factor. Ganancia del artista = precio público − precio base. El mínimo es 1.00×.
                                                    </small>
                                                </FormGroup>

                                                <FormGroup>
                                                    <Label>Cover photo</Label>

                                                    <Input type="file"
                                                        id="artistCoverImage"
                                                        onChange={_handleCoverFileUpload}
                                                    />
                                                </FormGroup>

                                                <FormGroup>
                                                    <Label>Bio del artista</Label>
                                                    <Input
                                                        type="textarea"
                                                        className="form-control"
                                                        value={artistBio}
                                                        rows={4}
                                                        onChange={event => setArtistBio(event.target.value)}
                                                    />
                                                </FormGroup>

                                                <FormGroup>
                                                    <Label>Statement / Semblanza</Label>
                                                    <Input
                                                        type="textarea"
                                                        className="form-control"
                                                        value={artistStatement}
                                                        rows={4}
                                                        onChange={event => setArtistStatement(event.target.value)}
                                                    />
                                                </FormGroup>

                                                <FormGroup>
                                                    <Label>Sitio web</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        value={artistWebsiteUrl}
                                                        onChange={event => setArtistWebsiteUrl(event.target.value)}
                                                    />
                                                </FormGroup>

                                                <FormGroup>
                                                    <Label>Instagram</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        value={artistInstagramUrl}
                                                        onChange={event => setArtistInstagramUrl(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </React.Fragment>
                                        )}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

export default withRouter(FormPage)
